/**
 * Every query key in one place, so invalidation after a mutation cannot drift
 * from the key a hook reads under.
 */
export const queryKeys = {
  departments: ["departments"] as const,
  department: (id: string) => ["departments", id] as const,
  documents: ["documents"] as const,
  document: (id: string) => ["documents", id] as const,
  documentFile: (id: string) => ["documents", id, "file"] as const,
  // Under "file", so replacing the file also drops its converted preview.
  documentPreview: (id: string) => ["documents", id, "file", "pdf"] as const,
  documentLink: (id: string) => ["documents", id, "file", "link"] as const,
  announcements: ["announcements"] as const,
  readAnnouncements: ["announcements", "read"] as const,
  activities: ["activities"] as const,
  activity: (id: string) => ["activities", id] as const,
  managers: ["managers"] as const,
  activityLog: ["activity-log"] as const,
  quickLinks: ["quick-links"] as const,
  profile: (userId: string) => ["profile", userId] as const,
} as const;
